<template>
  <div class="container catch-covid">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="20" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip skip="preventativehealth">
    </back-and-skip>
    <div class="row pt-5 pt-lg-4">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/catch_covid.svg" alt="catch-covid">
      </div>
    </div>
    <div class="row row-title">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('catchCovid.title') }}
        </label>
      </div>
    </div>
    <yes-no
      @yes="yes"
      @no="no">
    </yes-no>
  </div>
</template>

<script>
import BackAndSkip from '../components/BackAndSkip.vue'
import YesNo from '../components/YesNoButtons.vue'

export default {
  components: {
    BackAndSkip,
    YesNo
  },
  methods: {
    yes () {
      const answer = {
        key: 'catch_covid',
        value: 'yes'
      }

      this.$store.commit('SET_DATA_SURVEY', answer)

      this.$router.push({
        name: 'wouldgetvaccinated'
      })
    },
    no () {
      const answer = {
        key: 'catch_covid',
        value: 'no'
      }

      this.$store.commit('SET_DATA_SURVEY', answer)

      this.$router.push({
        name: 'wouldgetvaccinated'
      })
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'catchcovid19')
  }
}
</script>

<style>
.catch-covid .img-question {
  width: 100%;
  height: 27vh;
}

.catch-covid .title {
  font-weight: 700;
  font-size: 1.4rem;
}

.catch-covid .row-title {
  padding-top: 2rem;
  padding-bottom: 8rem;
}

@media screen and (device-aspect-ratio: 40/71) {
  .catch-covid .img-question {
    width: 100%;
    height: 22vh;
  }

  .catch-covid .title {
    font-size: 1.2rem;
  }

  .catch-covid .row-title {
    padding-top: 2rem;
    padding-bottom: 3.5rem;
  }
}
</style>
